import { combineReducers } from "redux"
import userReducer from "./user"
import { UserState } from "./user/reducer"
import updatePatientConditionStateReducer, {
	UpdatePatientConditionState
} from "./updateCondition/reducer"
import changeConditionReducer, {
	ChangeConditionState
} from "./changeCondition/reducer"
import nhsNumberImportReducer, {
	NhsNumberImportState
} from "./nhsNumber/reducer"

export interface PatientsState {
	updateCondition: UpdatePatientConditionState
	changeCondition: ChangeConditionState
	nhsNumber: NhsNumberImportState
	user: UserState
}

const patientsReducer = combineReducers({
	updateCondition: updatePatientConditionStateReducer,
	changeCondition: changeConditionReducer,
	nhsNumber: nhsNumberImportReducer,
	user: userReducer
})

export default patientsReducer
